import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Anniversaryqutes = () => {
    return (
        <Row className='p-4 d-flex align-items-center annversaryqutesrow my-4'>
            <Col className="p-4" lg={6} md={10} sm={12}>
                <h1 className="hometitle">A Moment Well Remembered</h1>
                <p>Founder of BloomsyBox, Juan Palacio, designed his very first floral arrangement when gifting his wife an anniversary present! His very own relationship inspired the idea of BloomsyBox.com. Your celebration should be beautiful, so let us do all the hard work! BloomsyBox is a monthly subscription which allows you to send your loved one the most impressive bouquet of flowers, month after month. Each bouquet is made especially for each occasion and blends luxury, organic designs, and sustainable principles together for a memorable anniversary gift that lasts all year long! Every bouquet is exquisitely unique. No matter your style or budget, BloomsyBox delivers monthly high quality floral fantasy to your door. It couldn’t be easier!</p>
            </Col>
        </Row>
    );
};

export default Anniversaryqutes;